import {  FromObservable  } from './FromObservable';

export const from = FromObservable.create;


// WEBPACK FOOTER //
// ../../src/observable/from.ts